/* aurora-main-product.js
   Powers sections/aurora-main-product.liquid:
     <aurora-product-gallery>  carousel + thumbs + dots + variant media sync + lightbox
     [data-aurora-showmore]    description "Read more" toggle
     [data-aurora-stickybar]   sticky add-to-cart bar

   Variant media: we do NOT use Dawn's <media-gallery>, so product-info.js can't call
   setActiveMedia() on us. Instead we subscribe to the pubsub `variantChange` event that
   product-info.js publishes, and scroll to the variant's featured media ourselves. */
(function () {
  /* ------------------------------------------------------------------ gallery */
  if (!customElements.get('aurora-product-gallery')) {
    customElements.define(
      'aurora-product-gallery',
      class AuroraProductGallery extends HTMLElement {
        connectedCallback() {
          if (this.inited) return;
          this.inited = true;

          this.list = this.querySelector('.aurora-pdp__media-list');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('.aurora-pdp__media'));
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-aurora-thumb]'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('.aurora-pdp__dot'));
          this.arrowPrev = this.querySelector('[data-aurora-arrow="prev"]');
          this.arrowNext = this.querySelector('[data-aurora-arrow="next"]');
          this.thumbsEl = this.querySelector('.aurora-pdp__thumbs');
          this.thumbsPrev = this.querySelector('[data-aurora-thumbs-arrow="prev"]');
          this.thumbsNext = this.querySelector('[data-aurora-thumbs-arrow="next"]');
          this.current = 0;
          this.sectionId = this.dataset.section;
          if (!this.list || !this.slides.length) return;

          this.grouping = this.hasAttribute('data-media-grouping');
          this.groupIndex = parseInt(this.dataset.groupOptionIndex, 10);
          if (this.grouping) this.applyGroup(this.dataset.filterSelected);

          this.thumbs.forEach(
            function (t) {
              t.addEventListener('click', function () { this.goTo(parseInt(t.dataset.index, 10)); }.bind(this));
            }.bind(this)
          );

          if (this.arrowPrev) this.arrowPrev.addEventListener('click', function () { this.step(-1); }.bind(this));
          if (this.arrowNext) this.arrowNext.addEventListener('click', function () { this.step(1); }.bind(this));

          if (this.thumbsPrev) this.thumbsPrev.addEventListener('click', function () { this.scrollThumbs(-1); }.bind(this));
          if (this.thumbsNext) this.thumbsNext.addEventListener('click', function () { this.scrollThumbs(1); }.bind(this));

          var t;
          this.list.addEventListener(
            'scroll',
            function () { clearTimeout(t); t = setTimeout(this.syncActive.bind(this), 80); }.bind(this),
            { passive: true }
          );
          if (this.thumbsEl) {
            var tt;
            this.thumbsEl.addEventListener(
              'scroll',
              function () { clearTimeout(tt); tt = setTimeout(this.updateThumbArrows.bind(this), 80); }.bind(this),
              { passive: true }
            );
          }

          if (this.hasAttribute('data-lightbox')) this.initLightbox();
          this.initVariantSync();
          this.syncActive();
          this.updateArrows();
          this.updateThumbArrows();
          window.addEventListener('load', this.updateThumbArrows.bind(this));
        }

        /* scroll the thumbnail STRIP itself (its own overflow) — vertical for left/right,
           horizontal for the bottom strip. Independent of the main-image arrows. */
        scrollThumbs(dir) {
          var el = this.thumbsEl;
          if (!el) return;
          var vertical = el.scrollHeight > el.clientHeight + 2;
          if (vertical) el.scrollBy({ top: dir * el.clientHeight * 0.8, behavior: 'smooth' });
          else el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' });
        }

        updateThumbArrows() {
          var el = this.thumbsEl;
          if (!el || (!this.thumbsPrev && !this.thumbsNext)) return;
          var vertical = el.scrollHeight > el.clientHeight + 2;
          var pos = vertical ? el.scrollTop : el.scrollLeft;
          var max = vertical ? el.scrollHeight - el.clientHeight : el.scrollWidth - el.clientWidth;
          if (this.thumbsPrev) this.thumbsPrev.disabled = pos <= 2;
          if (this.thumbsNext) this.thumbsNext.disabled = pos >= max - 2 || max <= 2;
        }

        /* is the stage a scrolling carousel right now? stacked/grid on desktop are not */
        isCarousel() {
          return this.list.scrollWidth > this.list.clientWidth + 4;
        }

        /* --- media grouping: show only the selected option value's media ------ */
        applyGroup(value) {
          if (!this.grouping || !value) return;
          var shown = 0;
          var hide = function (el, off) { if (el) el.classList.toggle('is-hidden', off); };
          for (var i = 0; i < this.slides.length; i++) {
            var g = this.slides[i].dataset.mediaGroup;
            // a media with no group tag always shows (defensive: never hide the whole gallery)
            var off = !!g && g !== value;
            if (!off) shown++;
            hide(this.slides[i], off);
            hide(this.dots[i], off);
            if (this.thumbs[i]) hide(this.thumbs[i].parentElement, off);
          }
          if (!shown) {
            // nothing matched — reveal everything rather than render an empty gallery
            for (var j = 0; j < this.slides.length; j++) {
              hide(this.slides[j], false); hide(this.dots[j], false);
              if (this.thumbs[j]) hide(this.thumbs[j].parentElement, false);
            }
            return;
          }
          this.list.scrollLeft = 0;
          this.syncActive();
        }

        visible() {
          return this.slides.filter(function (sl) { return !sl.classList.contains('is-hidden'); });
        }

        goTo(index) {
          var slide = this.slides[index];
          if (!slide) return;
          if (this.isCarousel()) {
            this.list.scrollTo({ left: slide.offsetLeft - this.list.offsetLeft });
          } else {
            slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          this.setActive(index);
        }

        /* Show a media because the VARIANT changed, in whatever layout is running.

           A carousel scrolls its track. The grid layouts (stacked, grid 2-up, grid mixed,
           sticky first image) already show every shot at once, so there is no slide to
           scroll to — scrolling the window instead threw the shopper ~2,000px down the
           page, away from the buy button, which is what "the image does not change" looked
           like on a stacked gallery. There the variant's media becomes the LEAD image
           instead, via flex/grid order, and the page does not move. */
        showForVariant(index) {
          if (!this.slides[index]) return;
          if (this.isCarousel()) return this.goTo(index);
          for (var i = 0; i < this.slides.length; i++) {
            this.slides[i].style.order = i === index ? '-1' : '';
          }
          this.setActive(index);
        }

        setActive(index) {
          this.current = index;
          this.thumbs.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
          this.dots.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
          this.scrollThumbIntoView(index);
          this.updateArrows();
        }

        /* Keep the active thumbnail visible in its strip when the main image is swapped
           (swipe / arrow / variant). Scrolls the STRIP only — never the page. */
        scrollThumbIntoView(index) {
          var t = this.thumbs[index];
          if (!t) return;
          var strip = t.closest('.aurora-pdp__thumbs');
          if (!strip) return;
          var tr = t.getBoundingClientRect();
          var sr = strip.getBoundingClientRect();
          if (strip.scrollWidth > strip.clientWidth + 2) {
            strip.scrollLeft += (tr.left - sr.left) - (sr.width - tr.width) / 2;
          } else if (strip.scrollHeight > strip.clientHeight + 2) {
            strip.scrollTop += (tr.top - sr.top) - (sr.height - tr.height) / 2;
          }
        }

        /* step one shot forward/back through the currently-visible media */
        step(dir) {
          var vis = this.visible();
          if (vis.length < 2) return;
          var curEl = this.slides[this.current];
          var pos = vis.indexOf(curEl);
          if (pos < 0) pos = 0;
          var target = vis[pos + dir];
          if (!target) return;
          this.goTo(this.slides.indexOf(target));
        }

        /* dim the arrow that has nowhere left to go */
        updateArrows() {
          if (!this.arrowPrev && !this.arrowNext) return;
          var vis = this.visible();
          var pos = vis.indexOf(this.slides[this.current]);
          if (pos < 0) pos = 0;
          if (this.arrowPrev) this.arrowPrev.disabled = pos <= 0;
          if (this.arrowNext) this.arrowNext.disabled = pos >= vis.length - 1;
        }

        /* which slide is centred in the stage? */
        syncActive() {
          if (!this.isCarousel()) return;
          var box = this.list.getBoundingClientRect();
          var centre = box.left + box.width / 2;
          var best = -1;
          var bd = Infinity;
          for (var i = 0; i < this.slides.length; i++) {
            if (this.slides[i].classList.contains('is-hidden')) continue; // zero-size when hidden
            var r = this.slides[i].getBoundingClientRect();
            var d = Math.abs(r.left + r.width / 2 - centre);
            if (d < bd) { bd = d; best = i; }
          }
          if (best >= 0) this.setActive(best);
        }

        /* --- follow the selected variant's featured media ------------------- */
        initVariantSync() {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribe = subscribe(
            PUB_SUB_EVENTS.variantChange,
            function (event) {
              var data = event && event.data;
              if (!data || data.sectionId !== this.sectionId) return;
              var variant = data.variant;
              if (!variant) return;
              // re-filter before scrolling: the target slide may currently be hidden
              if (this.grouping && variant.options && !isNaN(this.groupIndex)) {
                this.applyGroup(variant.options[this.groupIndex]);
              }
              var mediaId = variant.featured_media && variant.featured_media.id;
              if (!mediaId) return;
              for (var i = 0; i < this.slides.length; i++) {
                if (String(this.slides[i].dataset.mediaRawId) === String(mediaId)) { this.showForVariant(i); return; }
              }
            }.bind(this)
          );
        }

        disconnectedCallback() { if (this.unsubscribe) this.unsubscribe(); }

        /* --- lightbox (follows the Aurora drawer conventions) --------------- */
        initLightbox() {
          var script = document.querySelector('[data-aurora-pdp-media]');
          var media = [];
          try { media = JSON.parse(script.textContent); } catch (e) { return; }
          var images = media.filter(function (m) { return m.type === 'image'; });
          if (!images.length) return;

          this.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-aurora-zoom]');
            if (!btn) return;
            var slideIndex = parseInt(btn.dataset.index, 10);
            var id = this.slides[slideIndex] && this.slides[slideIndex].dataset.mediaRawId;
            var i = 0;
            images.forEach(function (m, n) { if (String(m.id) === String(id)) i = n; });
            openLightbox(images, i);
          }.bind(this));
        }
      }
    );
  }

  /* one lightbox shared by the page; lifted to <body> so no ancestor can clip it */
  var lb = null;
  function buildLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'aurora-lightbox';
    lb.innerHTML =
      '<div class="aurora-lightbox__overlay" data-lb-close></div>' +
      '<div class="aurora-lightbox__panel">' +
      '<img class="aurora-lightbox__img" alt="">' +
      '<button type="button" class="aurora-lightbox__close" data-lb-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<button type="button" class="aurora-lightbox__nav aurora-lightbox__nav--prev" data-lb-prev aria-label="Previous">' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<button type="button" class="aurora-lightbox__nav aurora-lightbox__nav--next" data-lb-next aria-label="Next">' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<div class="aurora-lightbox__thumbs" data-lb-thumbs></div>' +
      '</div>';
    document.body.appendChild(lb);
    return lb;
  }

  function openLightbox(images, index) {
    var el = buildLightbox();
    var img = el.querySelector('.aurora-lightbox__img');
    var thumbsWrap = el.querySelector('[data-lb-thumbs]');
    var i = index;
    var single = images.length < 2;
    el.querySelector('[data-lb-prev]').hidden = single;
    el.querySelector('[data-lb-next]').hidden = single;

    // (re)build the bottom thumbnail strip for this product's images
    thumbsWrap.innerHTML = '';
    thumbsWrap.hidden = single;
    var thumbBtns = [];
    if (!single) {
      images.forEach(function (m, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aurora-lightbox__thumb';
        var src = m.src + (m.src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        b.innerHTML = '<img src="' + src + '" alt="' + (m.alt || '').replace(/"/g, '&quot;') + '" loading="lazy">';
        b.addEventListener('click', function () { show(n); });
        thumbsWrap.appendChild(b);
        thumbBtns.push(b);
      });
    }

    function show(n) {
      i = (n + images.length) % images.length;
      img.src = images[i].src;
      img.alt = images[i].alt || '';
      thumbBtns.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      if (thumbBtns[i]) thumbBtns[i].scrollIntoView({ inline: 'center', block: 'nearest' });
    }
    function close() {
      el.classList.remove('is-open');
      document.body.classList.remove('aurora-lightbox-open');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(i - 1);
      else if (e.key === 'ArrowRight') show(i + 1);
    }

    el.onclick = function (e) {
      if (e.target.closest('[data-lb-close]')) close();
      else if (e.target.closest('[data-lb-prev]')) show(i - 1);
      else if (e.target.closest('[data-lb-next]')) show(i + 1);
    };

    show(index);
    document.addEventListener('keydown', onKey);
    document.body.classList.add('aurora-lightbox-open');
    // force a reflow so the opacity transition has a "from" frame; don't defer to rAF,
    // which never fires while the tab is backgrounded
    void el.offsetWidth;
    el.classList.add('is-open');
  }

  /* --------------------------------------------------- description "Read more" */
  function initShowMore(root) {
    (root || document).querySelectorAll('[data-aurora-showmore]').forEach(function (wrap) {
      if (wrap.dataset.smInit) return;
      wrap.dataset.smInit = '1';
      var btn = wrap.querySelector('[data-aurora-showmore-btn]');
      var body = wrap.querySelector('.aurora-pdp__description-body');
      if (!btn || !body) return;
      // nothing to truncate -> hide the toggle entirely
      var clampH = parseFloat(getComputedStyle(body).maxHeight) || 0;
      if (clampH && body.scrollHeight <= clampH + 4) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-expanded');
        btn.querySelector('[data-more]').hidden = open;
        btn.querySelector('[data-less]').hidden = !open;
      });
    });
  }

  /* ----------------------------------------------------- sticky add-to-cart bar */
  function initStickyBar(root) {
    (root || document).querySelectorAll('[data-aurora-stickybar]').forEach(function (bar) {
      if (bar.dataset.sbInit) return;
      bar.dataset.sbInit = '1';
      // `closest` fails once the bar has been lifted to <body>, and a second init pass
      // would then treat it as an orphan and delete it — fall back to the page's PDP.
      var section = bar.closest('.aurora-pdp') || document.querySelector('.aurora-pdp');
      var buybox = section && section.querySelector('[data-aurora-buybox]');
      var addBtn = bar.querySelector('[data-aurora-sticky-add]');
      if (!buybox || !addBtn) { bar.remove(); return; }

      // Lift the bar OUT of the section (same move the drawers make). Every template
      // section owns a stacking context, so a fixed bar left inside the product section
      // is capped at that section's paint order and every later section covers it.
      // A section re-render ships a fresh copy, so retire any bar lifted earlier.
      document.querySelectorAll('body > [data-aurora-stickybar]').forEach(function (old) {
        if (old !== bar) old.remove();
      });
      if (bar.parentElement !== document.body) document.body.appendChild(bar);

      var qtyInput = bar.querySelector('[data-sb-qty]');
      var realQty = section.querySelector('.quantity__input');

      function clampQty() {
        var n = parseInt(qtyInput.value, 10);
        if (!n || n < 1) n = 1;
        qtyInput.value = n;
        return n;
      }

      bar.querySelectorAll('[data-sb-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          qtyInput.value = Math.max(1, clampQty() + parseInt(btn.dataset.sbQtyStep, 10));
        });
      });
      if (qtyInput) qtyInput.addEventListener('change', clampQty);

      // The bar's select drives the REAL variant picker rather than keeping its own idea
      // of the variant: clicking the matching option inputs lets <variant-selects> run its
      // normal update, so price, availability, media and the hidden id all stay correct.
      var vSelect = bar.querySelector('[data-sb-variant]');
      if (vSelect) {
        vSelect.addEventListener('change', function () {
          var opt = vSelect.options[vSelect.selectedIndex];
          if (!opt) return;
          var wanted = opt.textContent.trim().split(' / ');
          var groups = section.querySelectorAll('variant-selects .product-form__input');
          groups.forEach(function (group, i) {
            var value = wanted[i];
            if (value === undefined) return;
            var radios = group.querySelectorAll('input[type="radio"]');
            for (var r = 0; r < radios.length; r++) {
              if (radios[r].value.trim() === value && !radios[r].checked) { radios[r].click(); return; }
            }
            var sel = group.querySelector('select');
            if (sel) {
              for (var o = 0; o < sel.options.length; o++) {
                if (sel.options[o].value.trim() === value) {
                  sel.selectedIndex = o;
                  sel.dispatchEvent(new Event('change', { bubbles: true }));
                  return;
                }
              }
            }
          });
        });
      }

      // the bar's button just clicks the real submit button, so Dawn's <product-form>
      // does the AJAX add and opens the cart drawer exactly as it normally would
      addBtn.addEventListener('click', function () {
        if (realQty && qtyInput) {
          realQty.value = clampQty();
          realQty.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var real = section.querySelector('button[type="submit"][name="add"]');
        if (real) real.click();
      });

      if (!('IntersectionObserver' in window)) return;
      // Watch the real Add to cart button, and show the bar only once it has been scrolled
      // PAST — i.e. it left the TOP of the viewport.
      //
      // "not intersecting" alone is not enough: it is equally true while the button is
      // still BELOW the fold and the shopper has not reached it yet, which popped the bar
      // over a button they had not even scrolled to. boundingClientRect.top < 0 is what
      // separates "gone above" from "not there yet".
      //
      // no rootMargin: a negative bottom margin shrinks the root and pops the bar while
      // the button is still on screen.
      var watch = section.querySelector('button[type="submit"][name="add"]') || buybox;
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      });
      io.observe(watch);
    });
  }

  /* --------------------------------------------------------------- popup block */
  /* Follows the Aurora drawer conventions: overlay + panel are lifted to <body>, the
     overlay MUST be display:block (Dawn's base.css hides empty divs), Escape / overlay
     click / outside click all close it. */
  if (!customElements.get('aurora-popup')) {
    customElements.define(
      'aurora-popup',
      class AuroraPopup extends HTMLElement {
        connectedCallback() {
          if (this.inited) return;
          this.inited = true;
          this.trigger = this.querySelector('[data-popup-open]');
          this.overlay = this.querySelector('.aurora-popup__overlay');
          this.panel = this.querySelector('.aurora-popup__panel');
          if (!this.trigger || !this.overlay || !this.panel) return;

          document.body.appendChild(this.overlay);
          document.body.appendChild(this.panel);

          this.onKey = function (e) { if (e.key === 'Escape') this.close(); }.bind(this);
          this.onDocClick = function (e) {
            if (this.panel.contains(e.target) || this.trigger.contains(e.target)) return;
            this.close();
          }.bind(this);

          this.trigger.addEventListener('click', this.open.bind(this));
          [this.overlay, this.panel].forEach(
            function (el) {
              el.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) this.close(); }.bind(this));
            }.bind(this)
          );
        }

        open() {
          this.overlay.classList.add('is-open');
          this.panel.classList.add('is-open');
          document.body.classList.add('aurora-popup-open');
          document.addEventListener('keydown', this.onKey);
          // bind on the next tick so THIS click doesn't immediately close it
          setTimeout(function () { document.addEventListener('click', this.onDocClick); }.bind(this), 0);
        }

        close() {
          this.overlay.classList.remove('is-open');
          this.panel.classList.remove('is-open');
          document.body.classList.remove('aurora-popup-open');
          document.removeEventListener('keydown', this.onKey);
          document.removeEventListener('click', this.onDocClick);
        }

        disconnectedCallback() {
          if (this.overlay) this.overlay.remove();
          if (this.panel) this.panel.remove();
        }
      }
    );
  }

  /* --------------------------------------------------------------- countdown */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-aurora-countdown]').forEach(function (el) {
      if (el.dataset.cdInit) return;
      el.dataset.cdInit = '1';
      // "2026-12-31 23:59" is not valid ISO in Safari — normalise to "2026-12-31T23:59"
      var end = new Date(String(el.dataset.end).trim().replace(' ', 'T')).getTime();
      if (isNaN(end)) { el.remove(); return; }

      var out = {
        days: el.querySelector('[data-days]'), hours: el.querySelector('[data-hours]'),
        mins: el.querySelector('[data-mins]'), secs: el.querySelector('[data-secs]')
      };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };

      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          el.classList.add('is-expired');
          // reveal the end-of-timer message (CSS hides the grid); the whole block
          // is hidden by CSS when data-hide="true".
          var endMsg = el.querySelector('[data-countdown-end]');
          if (endMsg) endMsg.hidden = false;
          clearInterval(timer); left = 0;
        }
        var s = Math.floor(left / 1000);
        out.days.textContent = pad(Math.floor(s / 86400));
        out.hours.textContent = pad(Math.floor((s % 86400) / 3600));
        out.mins.textContent = pad(Math.floor((s % 3600) / 60));
        out.secs.textContent = pad(s % 60);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* Keep a DROPDOWN's "Color: 14K Yellow Gold" label in sync.

     Dawn's updateSelectionMetadata writes the chosen value back into [data-selected-value]
     only for radio inputs; for a <select> it takes a different branch that updates a
     `.swatch` node and returns early when there isn't one. Our dropdown has no swatch node,
     so the label kept whatever value the page was rendered with. Delegated on document so
     it survives the section re-render that follows every variant change. */
  function initDropdownLabel() {
    if (initDropdownLabel.done) return;
    initDropdownLabel.done = true;
    document.addEventListener('change', function (e) {
      var select = e.target.closest && e.target.closest('.aurora-vp__select');
      if (!select || !select.selectedOptions.length) return;
      var group = select.closest('.aurora-vp__group');
      var label = group && group.querySelector('[data-selected-value]');
      if (label) label.textContent = select.selectedOptions[0].value;
    });
  }

  /* Keep the price-in-button in sync on variant change. The fetched section html
     (data.html) already re-rendered `[data-atc-price]` with `{{ variant.price | money }}`,
     so we copy it — no client-side money formatting, always correct. Subscribe once. */
  function initAtcPriceSync() {
    if (initAtcPriceSync.done) return;
    initAtcPriceSync.done = true;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html) return;
      var live = document.querySelector('#ProductSubmitButton-' + data.sectionId + ' [data-atc-price]');
      if (live) {
        var fresh = data.html.querySelector('[data-atc-price]');
        if (fresh) live.innerHTML = fresh.innerHTML;
      }

      /* The sticky bar lives on <body> now, so a section re-render never touches it —
         its price, image and select have to be updated by hand. The price comes from the
         freshly rendered markup, so it is never formatted client-side. */
      var bar = document.querySelector('[data-aurora-stickybar]');
      if (!bar) return;
      var barPrice = bar.querySelector('[data-sb-price]');
      var freshPrice = data.html.querySelector('[data-sb-price]');
      if (barPrice && freshPrice) barPrice.innerHTML = freshPrice.innerHTML;

      var barMedia = bar.querySelector('[data-sb-media] img');
      var variant = data.variant;
      if (barMedia && variant && variant.featured_media && variant.featured_media.preview_image) {
        barMedia.src = variant.featured_media.preview_image.src + '&width=160';
        barMedia.removeAttribute('srcset');
      }
      var barSelect = bar.querySelector('[data-sb-variant]');
      if (barSelect && variant) barSelect.value = variant.id;
    });
  }

  /* After a back-in-stock contact submit the page reloads; reopen the popup so the
     shopper sees the confirmation. (aurora-popup moves its panel to <body> and keeps
     a `.panel` reference.) */
  function initBackInStock(root) {
    (root || document).querySelectorAll('aurora-popup.aurora-pdp__bis').forEach(function (p) {
      var panel = p.panel || p.querySelector('.aurora-popup__panel');
      if (panel && panel.querySelector('.aurora-pdp__bis-success') && typeof p.open === 'function') {
        try { p.open(); } catch (e) {}
      }
    });
  }

  /* Share — native share sheet with a copy-link fallback. Delegated (survives editor re-renders). */
  function initShare() {
    if (initShare.done) return;
    initShare.done = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share-copy]');
      if (!btn) return;
      var wrap = btn.closest('[data-aurora-share]');
      if (!wrap) return;
      var url = wrap.dataset.shareUrl || location.href;
      var show = function () {
        var copied = wrap.querySelector('[data-share-copied]');
        if (copied) { copied.hidden = false; setTimeout(function () { copied.hidden = true; }, 2500); }
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(show).catch(function () {});
      } else {
        var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t);
        t.select(); try { document.execCommand('copy'); show(); } catch (err) {} t.remove();
      }
    });
  }

  /* Reco/upsell slider — a progress LINE (not dots). Thumb width = visible fraction,
     position = scroll progress. Rebinds cleanly (data-rs-init guard). */
  function initRecoSlider(root) {
    (root || document).querySelectorAll('.aurora-pdp__reco-list--slider').forEach(function (list) {
      if (list.dataset.rsInit) return;
      list.dataset.rsInit = '1';
      var thumb = list.parentElement && list.parentElement.querySelector('[data-reco-thumb]');
      if (!thumb) return;
      function update() {
        var n = list.children.length;
        if (n <= 1) { thumb.style.width = '100%'; thumb.style.left = '0'; return; }
        // always show the 1/n segment; only reposition by scroll once the list is scrollable
        // (before images load the list may not yet overflow — don't fall back to a full bar).
        var scrollable = list.scrollWidth > list.clientWidth + 1;
        var idx = scrollable ? Math.round(list.scrollLeft / list.clientWidth) : 0;
        idx = Math.max(0, Math.min(n - 1, idx));
        thumb.style.width = (100 / n) + '%';
        thumb.style.left = (idx * 100 / n) + '%';
      }
      list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      list.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', update); });
      update();
      setTimeout(update, 150);
      window.addEventListener('load', update);
    });
  }

  function init(root) { initShowMore(root); initStickyBar(root); initCountdown(root); initAtcPriceSync(); initDropdownLabel(); initBackInStock(root); initShare(); initRecoSlider(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // complementary products load async (aurora-recommendations.js) — wire the slider then
  document.addEventListener('aurora:reco:loaded', function (e) { initRecoSlider((e.detail && e.detail.el) || document); });

  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target || document;
    scope.querySelectorAll('[data-aurora-stickybar]').forEach(function (b) { b.removeAttribute('data-sb-init'); });
    scope.querySelectorAll('[data-aurora-showmore]').forEach(function (b) { b.removeAttribute('data-sm-init'); });
    scope.querySelectorAll('[data-aurora-countdown]').forEach(function (b) { b.removeAttribute('data-cd-init'); });
    init(scope);
  });
})();
